const Messaging = () => import(/* webpackChunkName: "messaging" */ '@/views/messaging/Index');
const Templates = () => import(
  /* webpackChunkName: "messaging" */ '@/views/messaging/Templates'
);
const Users = () => import(
  /* webpackChunkName: "messaging" */ '@/views/messaging/users/Index'
);
const UserList = () => import(
  /* webpackChunkName: "messaging" */ '@/views/messaging/users/List'
);
const UserDetail = () => import(
  /* webpackChunkName: "messaging" */ '@/views/messaging/users/Detail'
);
const Logs = () => import(/* webpackChunkName: "messaging" */ '@/views/messaging/Logs');

export default {
  path: '/messaging',
  component: Messaging,
  children: [
    {
      path: 'templates',
      name: 'MessagingTemplates',
      component: Templates
    },
    {
      path: 'users',
      name: 'MessagingUsers',
      component: Users,
      children: [
        {
          path: '',
          name: 'MessagingUsersList',
          component: UserList
        },
        {
          path: ':userId',
          name: 'MessagingUserConfig',
          component: UserDetail,
          props: true
        }
      ]
    },
    {
      path: 'logs',
      name: 'MessagingLogs',
      component: Logs
    }
  ]
};
